import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { linkList } from '../../types/types'

import './NavList.scss'

const NavList = () => {

    let currentPage = useLocation()
    return (
        <nav className='nav-list'>
            <ul>
                {linkList.map(item => {
                    let className: string = ''
                    if(currentPage.pathname.slice(1) === item.id)
                        className = 'active'
                    return (
                            <li 
                            key={item.id}
                            className = {className}>
                                <Link to={item.path}>{item.value}</Link>
                            </li>
                            )
                })}
            </ul>
        </nav>
    )
}

export default NavList